import { memo } from "react";
import { MiStackedTypography } from "@miplatform/components";
import { DATE_TIME_FORMATS } from "@miplatform/constants";
import { formatDate } from "@miplatform/utils";
import { Box } from "@mui/material";
import { ORDERS_DEFAULT_FIELD_WIDTH } from "../../ordersConstants";
import { OrdersListActionMenu } from "../ActionMenu/OrdersListActionMenu";

/**
 * CancelledOrderActions Component
 *
 * A React functional component that displays the actions available for a cancelled order.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.id - The unique identifier for the order.
 * @param {string} props.approvedStartDate - The approved start date for the order.
 * @param {string} props.cancelledDate - The cancelled date for the order.
 *
 * @returns {JSX.Element} The rendered NewOrderActions component.
 */
export const CancelledOrderActions = memo((props) => {
  const { cancelledDate, approvedStartDate } = props;

  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <MiStackedTypography
        title="Cancelled Date"
        description={
          cancelledDate
            ? formatDate(cancelledDate, DATE_TIME_FORMATS.FORMAT_MM_DD_YY)
            : "--"
        }
      />
      <MiStackedTypography
        title="Approved Date"
        titleProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
        description={
          approvedStartDate
            ? formatDate(approvedStartDate, DATE_TIME_FORMATS.FORMAT_MM_DD_YY)
            : "--"
        }
        descriptionProps={{ width: ORDERS_DEFAULT_FIELD_WIDTH }}
      />
      <OrdersListActionMenu
        menuViewConfig={{ OrderActivityDetails: true }}
        {...props}
      />
    </Box>
  );
});
